
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
    selector: 'app-cost-center-list',
    templateUrl: './../../../templates/forms/modals/document-large-list.component.html',
})
export class DocumentLargeListComponent implements OnInit {
    @Input()
    modalShow: boolean = true;

    @Input()
    lcFileNo;

    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    dataObj: any;

    documentList = [];

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "DocumentLargeListGrid";

    searchFields: any[] = ['DOC_AMENDMENT', 'CUSTOMER_NAME'];
    public searchString;
    constructor(private dataService: CommonService,
        public langService: LangService,
        public gridService: GridService) {
        this.colObj = [
            { headerName: langService.langData.documentQlonAmendment, field: 'DOC_AMENDMENT', sortable: true, filter: true, resizable: true, hide: false },
            { headerName: langService.langData.currency, field: 'CURRENCY', sortable: true, filter: true, resizable: true, hide: false },
            { headerName: langService.langData.customerName, field: 'CUSTOMER_NAME', sortable: true, filter: true, resizable: true, hide: false },
            { headerName: langService.langData.bankInfo, field: 'OWN_BANKDTL', sortable: true, filter: true, resizable: true, hide: false },
            { headerName: langService.langData.customerFullName, field: 'CUSTOMER_FULL_NAME', sortable: true, filter: true, resizable: true, hide: false },
            { headerName: langService.langData.lcFileNo, field: 'LC_FILE_NO', sortable: true, filter: true, resizable: true, hide: false },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }

    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);

        if (this.lcFileNo) {
            this.dataService.getDocumentsByLcFile(this.lcFileNo).subscribe(arg => { this.documentList = arg.body });
        } else {
            this.dataService.getDocumentsByLcFile().subscribe(arg => { this.documentList = arg.body });
        }
    }

    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}


